import type { IconData } from '@stacksjs/iconify-core'

export const locationPinDisabledRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.914 1.086a2 2 0 1 0-2.828 2.828l43 43a2 2 0 1 0 2.828-2.828l-8.017-8.018c3.146-3.952 5.672-8.994 5.672-15C44.569 9.708 35.359.5 24 .5A20.5 20.5 0 0 0 9.405 6.576zm14.86 14.86l10.349 10.349a7.318 7.318 0 1 0-10.349-10.349m-11.44-3.317a2 2 0 0 1 1.163 2.579a16.5 16.5 0 0 0-1.065 5.86c0 5.32 2.46 9.87 5.665 13.544c3.207 3.675 7.043 6.33 9.476 7.804c.891.54 1.962.54 2.854 0a45 45 0 0 0 5.297-3.762a2 2 0 1 1 2.552 3.08a49 49 0 0 1-5.777 4.103a6.72 6.72 0 0 1-6.999 0c-2.617-1.585-6.834-4.49-10.417-8.595s-6.651-9.556-6.651-16.174c0-2.558.467-5.011 1.324-7.275a2 2 0 0 1 2.578-1.164\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPinDisabledRemix
